import { CreateGatedAccessEventRequest, GetGatedAccessEventResponse } from '../../types';
import { GoogleTagEvent, buildQueryString, get, logWithAmplitude, logWithGoogleTagAndTopicOrganization, post, throwHttpError } from './api';

import { TELEMETRY_ENDPOINT } from '../constants';

export async function addGatedAccessEvent(amplitude_callsite: string, topic_id: string, gated_access_event: CreateGatedAccessEventRequest) {

    const response = await fetch(`${TELEMETRY_ENDPOINT}/api/topics/${topic_id}/gated_access_success`, post(gated_access_event));

    if (!response.ok) {
        await throwHttpError('An error occurred while adding the gated access event', response);
    }

    logWithAmplitude(amplitude_callsite, 'Gated Access Event', {
        topic_id,
        type: gated_access_event.gate_type,
        amount: gated_access_event.transaction_amount,
        transaction_id: gated_access_event.transaction_id,
        percent_to_creator: gated_access_event.transaction_percent_to_creator
    });

    logWithGoogleTagAndTopicOrganization(amplitude_callsite, GoogleTagEvent.MAP_GATED_ACCESS_SUCCESS, {
        lead_email: gated_access_event.email,
        gate_id: gated_access_event.email_gate_id,
        gate_type: gated_access_event.gate_type,
        transaction_id: gated_access_event.transaction_id,
    });
    return await Promise.resolve();
}

export async function getGatedAccessEvents(
    amplitude_callsite: string,
    topic_id: string,
    topic_key?: string
) {
    const queryString = buildQueryString({ topic_key });
    const response = await fetch(`/api/topics/${topic_id}/gated_accesses${queryString}`, get());

    if (!response.ok) {
        await throwHttpError('An error occurred while getting the gated accesses.', response);
    }

    logWithAmplitude(amplitude_callsite, 'Get Gated Accesses', { topic_id });
    return await (response.json() as Promise<GetGatedAccessEventResponse[]>);
}